import { TextInput } from '@app/components';
import { StyledForms } from '@app/components/styled/form/Form';
import React from 'react';

export const TaxForm = () => {
  return (
    <StyledForms.Form>

      <TextInput
        name="codeVAT"
        label="Code comptable VAT"
        keyboardType="numeric" />

      <TextInput
        name="nameVAT"
        label="Nom VAT"
        autoCapitalize="none"
        />

      <TextInput
        name="salesCodeHT"
        label="Code comptable vente HT"
        keyboardType="numeric" />

      <TextInput
        name="salesNameHT"
        label="Nom vente HT"
        autoCapitalize="none"
     />

    </StyledForms.Form>
  );
};

